<div class="str-dlg-mdl">
  <div class="store-set-blk">
    <div class="store-set-ui">
      <div class="dsgn-dscp st-dsgn-dscp">
        <div class="row">
          <div class="col-sm-12">
            <h3 class="cs-dsgn-ttl">Select Store</h3>
            <button class="closedialog cls-dlg-cls" mat-dialog-close="false" mat-button ><i
              class="material-icons">close</i></button>
          </div>
        </div>

        <form [formGroup]="storeForm" (ngSubmit)="fn_publish(storeForm)">
          <mat-dialog-content>
            <mat-radio-group>
            <ul class="storelist-bx popup-checkbx-list ">
              <li *ngFor="let store of storeList">
                <div class="mt-chk-blk">
                  <mat-radio-button   [value]="store.StoreId"
                                 #publishCheckbox (change)="fn_SelectPublishProducts($event, store.StoreId,storeForm)">
                    <app-store></app-store>
                    <span class="optwrp">{{store.StoreName}}</span>

                  </mat-radio-button>
                </div>
              </li>

              <li>
                <div class="mt-chk-blk">
                  <mat-radio-button [value]="0"
                                    (change)="addStore()">
                    <app-store></app-store>
                    <span class="optwrp">Create Store</span>

                  </mat-radio-button>
                </div>
              </li>
            </ul>
            </mat-radio-group>
          </mat-dialog-content>
          <button class="pblsh-mat-btn" mat-raised-button [disabled]="selectedStore==''">Sync with Shopify</button>
        </form>
      </div>
    </div>
  </div>
</div>
